import { render } from "./ContentTextEditor.vue?vue&type=template&id=1e9272b8&scoped=true&ts=true"
import script from "./ContentTextEditor.vue?vue&type=script&lang=ts"
export * from "./ContentTextEditor.vue?vue&type=script&lang=ts"

import "./ContentTextEditor.vue?vue&type=style&index=0&id=1e9272b8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e9272b8"]])

export default __exports__